/**
 * Chat blocks whose question is about to be typed: made by the canvas tool
 * that adds one, taken by the chat once it shows the input for that block.
 */
const awaited = new Set<string>();

export function requestChatBlockInput(blockId: string): void {
  awaited.add(blockId);
}

/** Whether the input was asked for; the request is used up by asking. */
export function takeChatBlockInputRequest(blockId: string): boolean {
  return awaited.delete(blockId);
}
